import environment from '@environment/'
import api from '@api/api'

const endpoints = environment.managerApi.endpoints

const createCompanyEffect = async (company, fileName) => {
  var bodyFormData = new FormData()

  for (const key in company) {
    const value = company[key]
    if (value instanceof Blob) bodyFormData.append(key, value, fileName)

    bodyFormData.append(key, value)
  }

  return await api.post(endpoints.company.create, bodyFormData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export { createCompanyEffect }
